const loginAndSignUp = {
  loginTips: "आपके पास पहले से HitPaw खाता है? <1>लॉग इन करें</1>",
  loginSuccessTips: "लॉगइन सफल",
  loginErrorTips: "लॉगइन विफल",
  loginAccountOrPasswordErrorTips: "आपका ईमेल या पासवर्ड गलत था। कृपया दोबारा कोशिश करें।",
  loginAccountNotExitErrorTips: "ईमेल पंजीकृत नहीं है",
  signUpTips: "अभी तक एक पंजीकृत प्रयोगकर्ता नहीं हैं?",
  rememberMe: "मुझे याद रखें",
  forgotPassword: "पासवर्ड भूल गए?",
  forgotPasswordTitle: "पासवर्ड भूल गए",
  verifyEmailBtn: "ईमेल सत्यापित करें",
  resetPasswordTitle: "पासवर्ड रिसेट",
  resetPasswordLabel: "अपना पासवर्ड रिसेट करें",
  resetPasswordPlaceholder: "नया पासवर्ड डालें",
  resetPasswordSuccessTips: "पासवर्ड सफलतापूर्वक रिसेट हो गया",
  signUpPrivacyTips: "साइन अप करके, आप हमारी <1>प्रयोग की शर्तों</1> और <3>गोपनीयता नीति</3> के लिए सहमति देते हैं",
  loginPrivacyTips: "आगे बढ़कर, आप हमारी <1>प्रयोग की शर्तों</1> और <3>गोपनीयता नीति</3> के लिए सहमति देते हैं",
  signUpSuccessTips: "आपका खाता सफलतापूर्वक पंजीकृत हो गया है！",
  getCode: "कोड प्राप्त करें",
  getCodeSuccessTips: "इसे आपके मेलबॉक्स में भेज दिया गया है, कृपया इसे देखें",
  verificationSuccessTips: "ईमेल पता सत्यापन सफल हुआ",
  surveyTitle: "HitPaw ऑनलाइन में आपका स्वागत है",
  surveyStep1: "<1>चरण 1</1>/3",
  surveyStep2: "<1>चरण 2</1>/3",
  surveyStep3: "<1>चरण 3</1>/3",
  surveyQuestion: "HitPaw का प्रयोग करने का आपका उद्देश्य क्या है?",
  surveyThemeQuestion: "अपनी पसंद का मोड चुनें",
  surveyAnswerOther: "अन्य",
  surveyAnswer1: "लाइफस्टाइल वीडियो",
  surveyAnswer2: "बिज़नेस वीडियो",
  surveyAnswer3: "कंपनी वीडियो",
  surveyAnswer4: "मार्केटिंग वीडियो",
  surveyAnswer5: "सोशल मीडिया वीडियो",
  surveyAnswer6: "स्लाइड शो वीडियो",
  surveyAnswer7: "वीडियो टूल",
  surveyAnswer8: "यात्रा का वीडियो",
  surveyAnswer9: "शादी का वीडियो",
  surveyAnswer10: "जन्मदिन वीडियो",
  surveyAnswer11: "बच्चे का वीडियो",
  surveyAnswer12: "जानवर का वीडियो",
  surveyAnswer13: "खाने का वीडियो",
  surveyAnswer14: "फैशन वीडियो",
  surveyAnswer15: "हॉलिडे वीडियो",
  surveyAnswer16: "खेल वीडियो",
  surveyAnswer17: "फोटोग्राफी वीडियो",
  surveyAnswer18: "वीडियो संगीत",
  surveyAnswerLightMode: "लाइट मोड",
  surveyAnswerDarkMode: "डार्क मोड",
  surveyNextBtn: "अगला",
  surveyBackBtn: "पीछे",
  surveyDoneBtn: "समाप्त",
  surveyStartBtn: "शुरू करें",
  logoutWarnTips: "क्या आप निश्चित रूप से लॉग आउट कर रहे हैं?",
  ContinuewithGoogle: 'Google के साथ जारी रखें',
  Securityverification: 'सुरक्षा परीक्षण',
  youraccount: 'आपका खाता',
  alreadyexiststoensurethesecuritypleaseverifyitfirst:
    ' पहले से मौजूद है, कृपया सत्यापित करें।',
};

export default loginAndSignUp;
